import { alertConstants } from '../_constants';

export function alertReducer(state = {}, action) {
  switch ( action.type ) {
    case alertConstants.SUCCESS:
      return {
        type: 'alert-success',
        message: action.message
      }
    case alertConstants.FAILURE:
      return {
        type: 'alert-failure',
        message: action.failure
      }
    default:
      return state
  }
}